import { TicketService } from 'src/app/shared/services/ticket.service';
import { REGION, W_K } from 'src/app/shared/constants/general.constants';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
import { sportticketsApi } from 'src/app/shared/constants/api.constants';
import { IMatchTicket } from 'src/app/shared/models/match-ticket.model';

declare global {
  interface Window {
    seatmapRenderer: any;
  }
}
@Component({
  selector: 'app-choose-seat',
  templateUrl: './choose-seat.component.html',
  styleUrls: ['./choose-seat.component.scss'],
})
export class ChooseSeatComponent implements OnInit, AfterViewInit, OnChanges {
  constructor(
    private ticketService: TicketService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService
  ) {}
  public eventManagerConfig;
  @Input() showTickets = false;
  public maxTicketBuy: number;
  public chartInitialized = false;
  public maxError: boolean;
  public ticketPricingObject = [];
  selectedSeats: any[] = [];
  public totalTicket: number = 1;
  @Output() selectedTickets: EventEmitter<any> = new EventEmitter();
  public defaultAvailableTciket = [];
  isMobile = false;
  @Input() showCartMobile = false;

  @Input() match: any;
  @Input() matchId: any;
  @Input() teamId: any;
  public tickets: any;
  public chart = null;
  public availableTciket = [];

  ngOnInit(): void {
    this.selectedSeats = [];
    this.availableTciket = [];
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }
  @ViewChild('seatmap', { static: true }) seatmap: ElementRef;

  ngAfterViewInit(): void {
    this.selectedSeats = [];
    this.availableTciket = [];
    this.selectedTickets.emit(0);
    this.getTeamMatchTicket();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['teamId'] &&
      changes['teamId'].currentValue !== changes['teamId'].previousValue
    ) {
      this.getTeamMatchTicket();
      document.getElementById('seatmap');
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
        window.location.reload();
      }
    }
  }

  public setSeatMapConfig(): void {
    this.eventManagerConfig = {
      region: REGION,
      workspaceKey: W_K,
      divId: 'chart',
      container: 'chart',
      event: this.matchId,
      language: this.translate.currentLang,
      pricing: this.ticketPricingObject,
      showSeatLabels: true,
      showSectionContents: 'onlyAfterZoom',
      priceFormatter: (price) => {
        if (Number(price) > 0) {
          if (this.translate.currentLang === 'ar') {
            return price + ' ريال';
          } else {
            return price + ' SR';
          }
        } else {
          if (this.translate.currentLang === 'ar') {
            return 'مجانية';
          } else {
            return 'Free';
          }
        }
      },
      showSectionPricingOverlay: true,
      maxSelectedObjects: this.ticketPricingObject,
      session: 'start',
      showLegend: false,
      showMinimap: true,
      fitTo: 'width',
      objectWithoutPricingSelectable: false,
      objectWithoutCategorySelectable: false,
      showFullScreenButton: false,
      availableCategories: [],
      objectLabel: (object) => {
        return object.labels.own;
      },

      tooltipInfo: (object) => {
        if (
          !object.labels.section ||
          !object.labels.parent ||
          !object.labels.own
        ) {
          return '';
        } else {
          if (this.translate.currentLang === 'ar') {
            return `القسم ${object.labels.section}، الصف: ${object.labels.parent}، المقعد: ${object.labels.own}`;
          } else {
            return `Section: ${object.labels.section}, Row: ${object.labels.parent}, Seat: ${object.labels.own}`;
          }
        }
      },
      objectTooltip: {
        showActionHint: true,
        showAvailability: true,
        showCategory: false,
        showLabel: false,
        showPricing: true,
        showUnavailableNotice: true,
        stylizedLabel: true,
        confirmSelectionOnMobile: 'auto',
      },
      onObjectSelected: (selectedObject) => {
        this.selectedSeats.push(selectedObject.id);
        // this.ticketService.updateBookTicket({
        //   selectedSeats: this.selectedSeats,
        // });
        this.incrementTicket(selectedObject.category);

        this.chart.changeConfig({
          availableCategories: [selectedObject.category.key], // this will deselect objects that belong to an unavailable category
        });
      },
      onObjectDeselected: (deselectedObject) => {
        if (this.selectedSeats.length > 0) {
          this.selectedSeats = this.selectedSeats.filter((seat) => {
            return seat !== deselectedObject.id;
          });
        }
        this.ticketService.updateBookTicket({
          selectedSeats: this.selectedSeats,
        });
        this.decrementTicket(deselectedObject.category);
        if (this.selectedSeats.length === 0) {
          this.chart.changeConfig({
            // availableCategories: [], // this will deselect objects that belong to an unavailable category
            availableCategories: [],
          });
        }
      },
      sectionColor: function (section) {
        if (
          section &&
          section.selectableCategories &&
          section.selectableCategories.length > 0
        ) {
          return section.selectableCategories[0].color;
        }
      },
      onRenderStarted: () => {},
      onRenderRendered: () => {},
      onChartRendered: (chart) => {
        this.chart = chart;

        this.chart.changeConfig({
          availableCategories: this.availableTciket,
        });
      },
    };
  }
  get shoopingCartFormGroup(): any[] {
    return this.ticketService.bookTicket.getValue()?.items || [];
  }
  public incrementTicket(category): void {
    let currentItems = this.ticketService.bookTicket.getValue()?.items || [];
    let existingItem = currentItems.find(
      (item) => item.ticket.id === category.key
    );

    if (existingItem) {
      let maxTicketBuy = existingItem.ticket.maxTicketQuantity;
      let totalTicket = this.ticketService.getTotalQuantity();

      if (totalTicket < maxTicketBuy) {
        let updatedItem = {
          ...existingItem,
          quantity: existingItem.quantity + 1,
        };
        this.ticketService.updateBookTicketItems(updatedItem);
        this.ticketService.updateBookTicket({
          teamId: existingItem.ticket.team.id,
        });
      }
    } else {
      this.ticketService.updateBookTicketItems({
        ticket: this.getTicketObjectFromCategoryId(category.key),
        quantity: this.totalTicket,
        date: this.match.date,
        time: this.match.time,
        selectedSeats: this.selectedSeats,
      });
    }
  }

  public decrementTicket(category): void {
    let currentItems = this.ticketService.bookTicket.getValue()?.items || [];
    let existingItem = currentItems.find(
      (item) => item.ticket.id === category.key
    );

    if (existingItem) {
      let updatedQuantity = existingItem.quantity - 1;

      if (updatedQuantity > 0) {
        let updatedItem = {
          ...existingItem,
          quantity: updatedQuantity,
          date: this.match.date,
          time: this.match.time,
          selectedSeats: this.selectedSeats,
        };
        this.ticketService.updateBookTicketItems(updatedItem);
      } else if (updatedQuantity === 0) {
        let updatedItem = {
          ...existingItem,
          quantity: 0,
          date: null,
          time: null,
          selectedSeats: [],
        };
        this.ticketService.updateBookTicketItems(updatedItem);
      }
    }
  }
  public setTicketPricing(tickets): void {
    tickets.forEach((ticket) => {
      this.defaultAvailableTciket.push(ticket.id);

      this.ticketPricingObject.push({
        category: ticket.id,
        quantity: ticket.maxTicketQuantity,
        price: ticket.needToPay
          ? Math.round(ticket.price * 1.15 * 100) / 100
          : 0,
        color: ticket.color,
        label:
          this.translate.currentLang === 'ar' ? ticket.nameAr : ticket.nameEn,
      });
    });

    this.availableTciket = [...this.defaultAvailableTciket];

    if (this.chart) {
      this.chart.changeConfig({
        availableCategories: this.availableTciket,
      });
    }
  }
  getTeamMatchTicket() {
    this.spinner.show();
    this.dataService
      .post(`${sportticketsApi}`, {
        matchId: this.matchId,
        teamId: this.teamId,
      })
      .subscribe((res: IMatchTicket[]) => {
        if (res) {
          this.tickets = res;
          this.spinner.hide();
          this.setSeatMapConfig();

          this.setTicketPricing(this.tickets);
          this.eventManagerConfig = { ...this.eventManagerConfig };
        }
      });
  }
  public setTicket(): void {
    let ticketItems = this.tickets.map((ticket) => ({
      ticket: ticket,
      quantity: 0,
    }));

    this.ticketService.updateBookTicket({ items: ticketItems });
  }

  // =========================

  getTicketQuantity() {
    for (let i = 0; i < this.tickets.length; i++) {
      if (this.tickets[i].quantity > 0) {
        return this.tickets[i].quantity;
      }
    }
  }

  getTicketId() {
    for (let i = 0; i < this.tickets.length; i++) {
      if (this.tickets[i].quantity > 0) {
        return this.tickets[i].ticket;
      }
    }
  }

  getTicketObjectFromCategoryId(categoryId) {
    for (let i = 0; i < this.tickets.length; i++) {
      if (this.tickets[i].id == categoryId) {
        return this.tickets[i];
      }
    }
  }
}
